module.exports = __webpack_public_path__ + "static/media/product-marketing-second.a9377220.jpg";